import { Injectable } from '@angular/core';

import { combineLatest, Observable } from 'rxjs';
import { map, shareReplay, take } from 'rxjs/operators';

import { ConfigService } from '../data-services/config.abstract.data-service';
import { ApplicationConfig } from '../entities/application-config.entity';
import { EnvironmentConfigService } from './environment-config.service';
import { SettingsConfigService } from './settings-config.service';

@Injectable({
    providedIn: 'root'
})
export class ApplicationConfigService extends ConfigService<ApplicationConfig> {
    protected readonly FALLBACK_VALUE: ApplicationConfig = {} as ApplicationConfig;
    protected readonly TYPE_NAME: string;

    constructor(
        protected settingsConfigService: SettingsConfigService,
        protected environmentConfigService: EnvironmentConfigService
    ) {
        super();
    }

    public initialize(): Observable<ApplicationConfig> {
        this.setConfig();

        this.initConfigListener();

        return this.config$.pipe(take(1));
    }

    protected setConfig(): void {
        const settingsConfig$ = this.settingsConfigService.getConfig();
        const environmentConfig$ = this.environmentConfigService.getConfig();

        this.config$ = combineLatest([settingsConfig$, environmentConfig$]).pipe(
            map(([settingsConfig, environmentConfig]) => ({
                ...settingsConfig,
                ...environmentConfig
            })),
            shareReplay(1)
        );
    }
}
